import { Component, inject } from '@angular/core';
import { Message } from './interfaces/message';
import { MessagesService } from './services/messages.service';

@Component({
    selector: 'big-chat-core-bot-input',
    template: '',
    standalone: false,
})
export class ChatCoreBotInputComponent {
    private readonly messagesService = inject(MessagesService);

    public chatMessage = '';
    public speakModeRecorded = false;

    public async addNewMessage(): Promise<string> {
        const message: Message = this.messagesService.createMessage(false, this.chatMessage);
        this.chatMessage = '';

        return this.messagesService.sendMessage(message);
    }
}
